import { store } from "../store/index";
import {
  userRefreshToken,
  userLogout,
  setAuthUser,
  setAuthToken,
  getProfile,
  setNotificationsSubs,
} from "../store/actions/AuthActions";
import {
  filterUser,
  filter,
  filterUserCore,
  assignUser,
  createUserCore,
  modifyPasswordUser,
} from "../store/actions/UserActions";

export const setNotificationSubscription = async (subscription) => {
  const result = await store.dispatch(setNotificationsSubs(subscription));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const profile = async () => {
  const result = await store.dispatch(getProfile());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const refreshToken = async () => {
  const result = await store.dispatch(userRefreshToken());
  if (result?.payload?.user) {
    await store.dispatch(setAuthUser(result.payload.user));
    await store.dispatch(
      setAuthToken({
        access_token: result.payload.access_token,
        token_expiration: result.payload.token_expiration,
      })
    );
    return result.payload;
  }

  return null;
};

export const logout = async () => {
  await store.dispatch(userLogout());

  return null;
};

/**
 * List user
 */
export const listFilter = async (filterData) => {
  const result = await store.dispatch(filter(filterData));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List all user
 */
export const filterAllUser = async (filter) => {
  const result = await store.dispatch(filterUser(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

/**
 * List core User
 */
export const listFilterCoreUser = async (filter) => {
  const result = await store.dispatch(filterUserCore(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Add user
 */
export const addUser = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(assignUser(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Create core User
 */
export const createCoreUser = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createUserCore(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Update Password
 */
export const updatePasswordUser = async (values, uuid) => {
  const objSend = { ...values };
  delete objSend.confirmPassword;
  const result = await store.dispatch(modifyPasswordUser(objSend, [uuid]));
  console.log(result)
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};
